import { render, staticRenderFns } from "./bandTradingPaw.vue?vue&type=template&id=b023b0f6&scoped=true"
import script from "./bandTradingPaw.vue?vue&type=script&lang=js"
export * from "./bandTradingPaw.vue?vue&type=script&lang=js"
import style0 from "./bandTradingPaw.vue?vue&type=style&index=0&id=b023b0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b023b0f6",
  null
  
)

export default component.exports